import React from 'react';
import './JsonTable.css';

interface JsonTableProps {
  value: any;
}

interface TableData {
  columns: string[];
  rows: {
    [key: string]: any[];
  };
}

const renderCell = (cellValue: any) => {
  if (cellValue === null || cellValue === undefined) return '';
  if (typeof cellValue === 'object') return JSON.stringify(cellValue);
  return String(cellValue);
};

const JsonTable: React.FC<JsonTableProps> = ({ value }) => {
  // If value is a string, try to parse as JSON
  let parsedValue = value;
  if (typeof value === 'string') {
    try {
      parsedValue = JSON.parse(value);
    } catch {
      // Not JSON, just use as is
      parsedValue = value;
    }
  }

  // Check if the value matches our expected format
  if (parsedValue && parsedValue.columns && parsedValue.rows) {
    const { columns, rows } = parsedValue as TableData;
    
    return (
      <table className="summary-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(rows).map(([rowKey, rowData]) => (
            <tr key={rowKey}>
              {rowData.map((cell, cellIndex) => (
                <td key={`${rowKey}-${cellIndex}`}>{renderCell(cell)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  // If value is a dictionary/object
  if (typeof parsedValue === 'object' && parsedValue !== null && !Array.isArray(parsedValue)) {
    const entries = Object.entries(parsedValue);
    return (
      <table className="summary-table">
        <tbody>
          {entries.map(([k, v]) => (
            <tr key={k}>
              <td>{k}</td>
              <td>{renderCell(v)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  // If value is a simple array
  if (Array.isArray(parsedValue)) {
    return (
      <table className="summary-table">
        <tbody>
          {parsedValue.map((item, idx) => (
            <tr key={idx}>
              <td>{renderCell(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  // Fallback: just show as text
  return <span>{String(parsedValue)}</span>;
};

export default JsonTable; 